import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import '@/assets/styles/components/chang-password-form.scss';
import Tips from '../../../components/Tips/Tips';
import { tipsType } from '@/constants/tips-type';
import { Validators } from '../../../helpers/functions';
import { changePassword } from '@/services/auth-services'
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP, Icons } from '@/configurations';
import eyescloseIcon from '@/assets/images/icons/eyesclose.png'
import eyesopenIcon from '@/assets/images/icons/eyesopen.png'
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import RSAKey from '@/assets/rsa_libs/RSA'
import { getSecureRandomCode } from '@/services/security-services'
class ChangePasswordForm extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      isSuccess: false,
      resText: '',
      isShowTips: false,
      isLoading: false,
      OldEyeStatus: false,
      NewEyeStatus: false,
      CofEyeStatus: false,
      lvST:'',
	  oldPasswordRefs:'',
	  oldPasswordRefshide:'',
	  lvNewPasswords:'',
	  lvNewPasswordshide:'',
	  confirmPasswordRefs:'',
	  confirmPasswordRefshide:'',
    }
  }

  sendChangePassword = () => {
    this.props.showFirstLoginTips(false)
    const { language } = this.props;
    const { lvST,oldPasswordRefs,lvNewPasswords } = this.state
    let lvOldPassword = oldPasswordRefs, lvNewPassword = lvNewPasswords
    var oldPwdLen = lvOldPassword.length;
    if (oldPwdLen<10) oldPwdLen='0'+oldPwdLen;
    var newPwdLen = lvNewPassword.length;
    if (newPwdLen<10) newPwdLen='0'+newPwdLen;
    var ChangePwdLen = lvNewPassword.length;
    if (ChangePwdLen<10) ChangePwdLen='0'+ChangePwdLen;
    lvNewPassword = this.do_encrypt(lvST + oldPwdLen + lvOldPassword + newPwdLen + lvNewPassword + ChangePwdLen + lvNewPassword);
    lvOldPassword = this.do_encrypt(lvST + lvOldPassword)
    const params = {
      [PARAMS.LOGIN_ID]: this.props.currentTradingAccount.clientID,
      [PARAMS.PASSWORD]: lvOldPassword,
      [PARAMS.NEW_PASSWORD]: lvNewPassword,
      [PARAMS.PASSWORD_ENCRYPT]: 'Y',
    }
    this.setState({
      isLoading:true
    })
    this.validators(() => {
      if (this.state.isSuccess) {
        this.props.changePassword(params, res => {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ isSuccess: true, resText: language.forgot_password_success, isShowTips: true, isLoading: false });
            this.props.callback()
          } else {
            if (res.result.errorCode === SERVICES_RESP.CHANGE_PASSWORD_FAIL) {
              const resText = language[res.result.errorCode]
              this.setState({ resText: resText, isSuccess: false, isShowTips: true, isLoading: false })
            } else {
              const resText = res.result.errorMessage
              this.setState({ resText: resText, isSuccess: false, isShowTips: true, isLoading: false })
            }
          }
        });
      }
    })
  }

  do_encrypt(pVal) {
    var rsa = new RSAKey();
    var rsa_modulus = iTradeEnv.rsa_modulus;
    var rsa_exponent = iTradeEnv.rsa_exponent;
    rsa.setPublic(rsa_modulus, rsa_exponent);
    var res = rsa.encrypt(pVal);
    return res;
  }

  validators = (callback = () => {}) => {
    if (this.state.lvST === '') {
      this.getSecureRandomCode()
       this.setState({
        isSuccess: false,
        isLoading:false,
      }, callback)                     
    } else if (this.state.oldPasswordRefs === '') {
       this.setState({
        isShowTips: true,
        isSuccess: false,
        isLoading:false,
        validatorCode: 1,
        resText: this.props.language.change_password_old_password_ph
      }, callback)
    } else if (this.state.lvNewPasswords === '') {
		this.setState({
        isShowTips: true,
        isSuccess: false,
        isLoading:false,
        validatorCode: 2,
        resText: this.props.language.change_password_new_password_ph
      }, callback)
    } else if (!Validators.password(this.state.lvNewPasswords)) {
		 this.setState({
        isShowTips: true,
        isSuccess: false,
        isLoading:false,
        validatorCode: 3,
        resText: this.props.language.change_password_password_required
      }, callback)
    } else if (this.state.oldPasswordRefs === this.state.lvNewPasswords) {
		 this.setState({
        isShowTips: true,
        isSuccess: false,
        isLoading:false,
        validatorCode: 2,
        resText: this.props.language.change_password_old_equal_new_password_ph
      }, callback)
    } else if (this.state.lvNewPasswords !== this.state.confirmPasswordRefs) {
		 this.setState({
        isShowTips: true,
        isSuccess: false,
        isLoading:false,
        validatorCode: 4,
        resText: this.props.language.error_message_password_not_match
      }, callback)
    } else {
		 this.setState({
			isSuccess: true,
			isShowTips: false,
			isLoading:false,
			validatorCode: 0
		  }, callback)
    }
  } 
 
  clearInfo = () => {
    this.props.showFirstLoginTips(true)
    this.oldPasswordRef.value = ''
    this.newPasswordRef.value = ''
    this.confirmPasswordRef.value = ''
    this.setState({
      validatorCode: 0,
      isShowTips: false,
	  oldPasswordRefs:'',
	  oldPasswordRefshide:'',
	  lvNewPasswords:'',
	  lvNewPasswordshide:'',
	  confirmPasswordRefs:'',
	  confirmPasswordRefshide:'',
    })
  }

  goToSecurities(){
    const { language } = this.props
    if(language.title === 'zh_TW' || language.title === 'zh_CN'){
      var tempWindow = window.open('_blank')
      tempWindow.location = iTradeEnv.securityTchLink;
    }else{
      var tempWindow = window.open('_blank')
      tempWindow.location = iTradeEnv.securityEngLink;
    }
  }

  render() {
    const { language, currentTradingAccount, infoTips,user } = this.props;
    const { isShowTips, isSuccess, validatorCode, resText, isLoading, OldEyeStatus, NewEyeStatus, CofEyeStatus,
	 oldPasswordRefs, oldPasswordRefshide,lvNewPasswords,lvNewPasswordshide,confirmPasswordRefs,confirmPasswordRefshide
	 } = this.state;
    return (
      <React.Fragment>
        {
          isShowTips && <Tips type={isSuccess ? tipsType.success : tipsType.error}>
            {resText}
          </Tips>
        }

        <section className={'show-table-info font-bold'}>
          <div className={'show-item'}>
            <div className={'item-left'}>{language.change_password_account_no}</div>
            <div>{currentTradingAccount.clientID ? currentTradingAccount.clientID : '-'}</div>
          </div>
          <div className={'show-item'}>
            <div className={'item-left'}>{language.change_password_account_name}</div>
            <div>{user.external.fullname ? user.external.fullname : '-'}</div>
          </div>
        </section>
        <section className={'form-table'}>
          <div className={'form-row'}>
            <div className={'form-label'}>
              {language.change_password_old_password}
            </div>
            <div className={'form-input'}>
              <input className={[1].includes(validatorCode) ? 'warning-border' : ''} ref={e => this.oldPasswordRef = e} type='text' value={OldEyeStatus ? oldPasswordRefs :oldPasswordRefshide}  placeholder={language.change_password_old_password_ph} 
              onChange={(e) => this.changePasswords(e,"OLD_PASSWORD")} onKeyDown={e => this.handleKeyPress(e,"OLD_PASSWORD")} 
			   onPaste={(e) => e.preventDefault()} onCopy={(e) => e.preventDefault()}/>  
              <div className="ipt-right">
                <img onClick={(e) => this.setState({ OldEyeStatus: !OldEyeStatus })} src={OldEyeStatus ? eyesopenIcon : eyescloseIcon} />
              </div>
            </div>
          </div>
          <div className={'form-row'}>
            <div className={'form-label'}>
              {language.change_password_new_password}
            </div>
            <div className={'form-input'}>
              <input className={[2, 3, 4].includes(validatorCode) ? 'warning-border' : ''}   ref={e => this.newPasswordRef = e} type='text' value={NewEyeStatus ? lvNewPasswords :lvNewPasswordshide} placeholder={language.change_password_new_password_ph} 
               onChange={(e) => this.changePasswords(e,"NEW_PASSWORD")} onPaste={(e) => e.preventDefault()} onCopy={(e) => e.preventDefault()} onKeyDown={e => this.handleKeyPress(e,"NEW_PASSWORD")}/>
              <div className="ipt-right" style={{top: '-66px'}}>
                <img onClick={(e) => this.setState({ NewEyeStatus: !NewEyeStatus })} src={NewEyeStatus ? eyesopenIcon : eyescloseIcon} />
              </div>
              <Tips type={tipsType.error} showIcon={false} isNoBgColor style={{ lineHeight: '1.5em', padding: 0, margin: '10px 0 0', textAlign: 'justify', fontWeight: '400' }}>
                  {language.change_password_password_required}
              </Tips>
            </div>
          </div>
          <div className={'form-row'}>
            <div className={'form-label'}>
              {language.change_password_confirm_password}
            </div>
            <div className={'form-input'}>
              <input className={[4].includes(validatorCode) ? 'warning-border' : ''} ref={e => this.confirmPasswordRef = e} type='text' value={CofEyeStatus ? confirmPasswordRefs :confirmPasswordRefshide}  placeholder={language.change_password_confirm_password_ph} 
               onChange={(e) => this.changePasswords(e,"CONFIRE_PASSWORD")} onPaste={(e) => e.preventDefault()} onCopy={(e) => e.preventDefault()}  onKeyDown={e => this.handleKeyPress(e,"CONFIRE_PASSWORD")}/>
              <div className="ipt-right">
                <img onClick={(e) => this.setState({ CofEyeStatus: !CofEyeStatus })} src={CofEyeStatus ? eyesopenIcon : eyescloseIcon} />
              </div>
            </div>
          </div>
        </section>
        <ul className="change-password-account-tips">
          <li>
            {language.change_password_account_tips_one}<b onClick={()=>this.goToSecurities()}>{language.change_password_account_tips_two}</b>{language.change_password_account_tips_three}
          </li>
        </ul>
        <section className="action_panel">
          <button className="clear" onClick={() => this.clearInfo()} disabled={isLoading}>{language.common_clear}</button>
          <button className="submit" onClick={this.sendChangePassword} disabled={isLoading}>{isLoading ? <Icons.Loading /> : language.common_submit}</button>
        </section>
      </React.Fragment>
    )
  }


  handleKeyPress = (e, type) => {
    if (e.keyCode === 9 || e.keyCode === 13) {
      e.preventDefault();

      switch (type) {
        case "OLD_PASSWORD":
          if (this.oldPasswordRef.value.length > 0) {
            this.newPasswordRef.focus();
          }
          break;
        case "NEW_PASSWORD":
          if (this.newPasswordRef.value.length > 0) {
            this.confirmPasswordRef.focus();
          }
          break;
        case "CONFIRE_PASSWORD":
          if (this.confirmPasswordRef.value.length > 0) {
            if (e.keyCode === 9) {
              this.oldPasswordRef.focus();
            } else if (e.keyCode === 13) {
              if (this.oldPasswordRef.value.length > 0 && this.newPasswordRef.value.length > 0
                && this.confirmPasswordRef.value.length > 0) {
                this.sendChangePassword();
              }
            }
          }
          break;
        default:
          break;
      }

    }
  }
  
  changePasswords = (e,type) => {
	  const {oldPasswordRefs,oldPasswordRefshide,lvNewPasswords,lvNewPasswordslength,confirmPasswordRefs,
	  lvNewPasswordshide,confirmPasswordRefshide}=this.state;
	  if(type=="OLD_PASSWORD"){
	  		  let newpassword="";
			  let strData="";
	  		    if(e.target.value.length>oldPasswordRefs.length){
					const s='*';
					const a=[];
					for(var i=1;i<=e.target.value.length;i++){a.push(s)};
					strData=a.join('');
	  		  	   const dpt=e.target.value;
	  		  	   let ddpData="";
	  		  	   if(dpt.length>=1){
	  		  	  		  const spstr = dpt.split("");
	  		  	  		  ddpData=spstr[spstr.length-1]
	  		  	   };
	  		  	   newpassword=oldPasswordRefs.concat(ddpData);
	  		    }else {
	  		  	  newpassword=oldPasswordRefs.slice(0,oldPasswordRefs.length-1);
				  strData=oldPasswordRefshide.slice(0,oldPasswordRefshide.length-1);
				  this.oldPasswordRef.selectionStart=e.target.value.length;
				  this.oldPasswordRef.selectionEnd=e.target.value.length;
	  		    }
			this.setState({
			  oldPasswordRefs: newpassword,
			  oldPasswordRefshide:strData,
			})
	  }else if(type=="NEW_PASSWORD"){
	  		let newpassword="";
			let strData="";
	  		  if(e.target.value.length>lvNewPasswords.length){
				  const s='*';
				  const a=[];
				  for(var i=1;i<=e.target.value.length;i++){a.push(s)};
				  strData=a.join('');
	  			  const dpt=e.target.value;
	  			  let ddpData="";
	  			   if(dpt.length>=1){
	  			  		  const spstr = dpt.split("");
	  			  		  ddpData=spstr[spstr.length-1]
	  			   };
	  			   newpassword=lvNewPasswords.concat(ddpData);
	  		  }else{
	  			  newpassword=lvNewPasswords.slice(0,lvNewPasswords.length-1);
				  strData=lvNewPasswordshide.slice(0,lvNewPasswordshide.length-1);
				  this.newPasswordRef.selectionStart=e.target.value.length;
				  this.newPasswordRef.selectionEnd=e.target.value.length;
	  		  }
	  		this.setState({
	  		  lvNewPasswords: newpassword,
	  		  lvNewPasswordshide:strData,
	  		})  
	  }else{
	  	let newpassword="";
		let strData="";
	  	  if(e.target.value.length>confirmPasswordRefs.length){
			   const s='*';
			   const a=[];
			   for(var i=1;i<=e.target.value.length;i++){a.push(s)};
			   strData=a.join('');
	  		   const dpt=e.target.value;
	  		   let ddpData="";
	  		   if(dpt.length>=1){
	  		  		  const spstr = dpt.split("");
	  		  		  ddpData=spstr[spstr.length-1]
	  		   };
	  		   newpassword=confirmPasswordRefs.concat(ddpData);
	  	  }else{
	  		  newpassword=confirmPasswordRefs.slice(0,confirmPasswordRefs.length-1);
			  strData=confirmPasswordRefshide.slice(0,confirmPasswordRefshide.length-1);
	  		  this.confirmPasswordRef.selectionStart=e.target.value.length;
	  		  this.confirmPasswordRef.selectionEnd=e.target.value.length;
	  	  }
	  	this.setState({
	  	  confirmPasswordRefs: newpassword,
	  	  confirmPasswordRefshide:strData,
	  	})  	  
	  }
  }

  componentDidUpdate(prevProps) {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount && JSON.stringify(currentTradingAccount) !=='{}') {
      this.getSecureRandomCode()
    }
  }

  getSecureRandomCode(){
    const { language, currentTradingAccount } = this.props;
    this.props.getSecureRandomCode({language:language.lang,clientID:currentTradingAccount.clientID,tradingAccountId:currentTradingAccount.clientID},res=>{
      if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        if(res.result.salt){
          this.setState({
            lvST:res.result.salt
          })
        }
      }
    })
  }

  componentDidMount() {
    if (JSON.stringify(this.props.currentTradingAccount) !=='{}') {
      this.getSecureRandomCode()
    }
  }
}

ChangePasswordForm.defaultProps = {
  innerRef: () => { },
  callback: () => { },
  infoTips: false
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    user: state.auth.user,
  }),
  dispatch => ({
    changePassword: (p, res) => changePassword(p, res),
    getSecureRandomCode: (p, res) => getSecureRandomCode(p, res)
  })
)(ChangePasswordForm);
